import FunctionalDiagram from '../../../components/vehicle/functional_diagram'

const FunctionalDiagramPage = () => {
  return <FunctionalDiagram />
}

export default FunctionalDiagramPage
